jQuery(document).ready(function () {
  function sync(e) {
    e.preventDefault();
    var el = e.target || e.srcElement;
    var form = jQuery(el).parent('form');
    var unindexed_array = form.serializeArray();
    var indexed_array = {};
    jQuery.map(unindexed_array, function (n, i) {
      indexed_array[n['name']] = n['value'];
    });
    var xhr = new XMLHttpRequest();

    xhr.onreadystatechange = function () {
      if (xhr.readyState == XMLHttpRequest.DONE) {
        location.reload();
      }
    };

    xhr.open('POST', form.attr('action'), true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify(indexed_array));
  }
});